import { DataSet } from "../core/Workbook";
import { getOrCreateOrder } from "./insertDeleteRows";

// All functions should not modify input parameters.

export function moveRow(
  fromIndex: number,
  toIndex: number
): (arg: DataSet) => DataSet {
  return (dataset) => {
    const newOrder = { ...getOrCreateOrder(dataset) }; // Create copy to avoid modifying original
    const rowToMove = newOrder[fromIndex];
    // Move all the rows between to and from up or down one depending on whether from is < or > to
    const moveDirection = toIndex > fromIndex ? 1 : -1;
    for (let i = fromIndex; i !== toIndex + moveDirection; i += moveDirection) {
      const j = i + moveDirection;
      if (j in newOrder) {
        newOrder[i] = newOrder[j];
      } else if (i in newOrder) {
        delete newOrder[i];
      }
    }
    if (rowToMove) {
      newOrder[toIndex] = rowToMove;
    } else {
      delete newOrder[toIndex];
    }
    return { ...dataset, ...{ naturalOrder: newOrder } };
  };
}
